interface IProps {
  rediredctUrl: string;
}

export interface IEmailHoneyPotControllerReturn {
  isTriggered:()=> boolean;
}

export const EmailHoneyPotController = (props: IProps): IEmailHoneyPotControllerReturn => { 

  const isTriggered = (): boolean => {
    const ids = ["firstname","lastname","email"];
    for(let idx: number = 0; idx<= ids.length-1; idx++) {
      const value =  (document.getElementById("firstname") as HTMLInputElement).value
      if(value != undefined && value != null && value.length >=1) return true
    }
    return false;
  }

  return {
    isTriggered
  }
}



